import React from 'react'
import Navbar from '../../components/Navbar'
import SmallFooter from '../../components/SmallFooter'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = () => {
    const [name, setName] = React.useState('')
    const [username, setUsername] = React.useState('')
    const [email, setEmail] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [bname, setBname] = React.useState('')
    const [pan, setPan] = React.useState('')
    const [gst, setGst] = React.useState('')

    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const validate = () => {
        if (name === '' || username === '' || email === '' || password === '' || bname === '') {
            notify('Please fill all the fields')
            return false
        }
        if (!name.match(/^[a-zA-Z ]+$/)) {
            notify('Name must contain only letters')
            return false
        }
        if (!username.match(/^[a-zA-Z0-9]+$/)) {
            notify('Username must contain only letters and numbers')
            return false
        }
        if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/)) {
            notify('Please enter a valid email')
            return false
        }
        if (!bname.match(/^[a-zA-Z ]+$/)) {
            notify('Business Name must contain only letters')
            return false
        }
        if (!gst.match(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[A-Z0-9]{1}$/)) {
            notify('Please enter a valid GST number')
            return false
        }

        if (!pan.match(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)) {
            notify('Please enter a valid PAN number')
            return false
        }

        if (!password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9!@#$%^&*]{8,}$/)) {
            notify('Password must be at least 8 characters long and contain at least one letter and one number')
            return false
        }

        return true
    }

    const handleSignup = (e) => {
        e.preventDefault()
        if (validate()) {
            try {
                fetch(process.env.REACT_APP_SERVER_URL + '/seller/signup', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        name,
                        username,
                        email: email.toLowerCase(),
                        password,
                        bname,
                        pan,
                        gst
                    })
                })
                    .then(res => res.json())
                    .then(data => {

                        if (data.success) {
                            notify(data.message)
                            document.getElementsByName('Name')[0].value = ''
                            document.getElementsByName('Username')[0].value = ''
                            document.getElementsByName('email')[0].value = ''
                            document.getElementsByName('Password')[0].value = ''
                            document.getElementsByName('bname')[0].value = ''
                            document.getElementsByName('pan')[0].value = ''
                            document.getElementsByName('gst')[0].value = ''

                        }
                        else {
                            notify(data.message)
                        }
                        
                    })
                    .catch(err => {
                        console.log(err)
                        notify(err.message)
                    })
            }
            catch (err) {
                console.log(err)
            }
        }
        console.log(name, username, email, password, bname, pan, gst)
    }

    React.useEffect(() => {
        if (localStorage.getItem('token')) {
            window.location.href = '/'
        }
    }, [])

    return (
        <div className="dark:bg-black dark:bg-none bg-[url('/public/assets/plants-sketch.png')] bg-cover">
            <Navbar />
            <div>
                <ToastContainer className='mt-20' />
            </div>
            <div className=' mt-8 justify-center items-center flex'>
                <div className='relative pb-10 w-[600px] mx-4 rounded-3xl shadow-2xl dark:bg-gray-900 bg-white bg-opacity-90 shadow-green-400'>

                    <div className="mt-12 dark:bg-gray-900  bg-white px-3 sm:mx-auto sm:w-full sm:max-w-md sm:px-10">
                        {/* <div>
                            <div>
                                <div className="mt-1 grid grid-cols-1 gap-2">
                                    <div>
                                        <button data-testid="google-oauth-btn" className="inline-flex w-full cursor-pointer items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500  dark:bg-gray-700 dark:hover:bg-gray-800 dark:border-gray-600   shadow-sm hover:bg-gray-50 disabled:cursor-wait disabled:opacity-50">
                                            <span className="sr-only">Sign up with Google</span>
                                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <clipPath id="p.0"><path d="m0 0l20.0 0l0 20.0l-20.0 0l0 -20.0z" clipRule="nonzero">
                                                </path>
                                                </clipPath>
                                                <g clipPath="url(#p.0)">
                                                    <path fill="currentColor" fillOpacity="0.0" d="m0 0l20.0 0l0 20.0l-20.0 0z" fillRule="evenodd">
                                                    </path>
                                                    <path fill="currentColor" d="m19.850197 8.270351c0.8574047 4.880001 -1.987587 9.65214 -6.6881847 11.218641c-4.700598 1.5665016 -9.83958 -0.5449295 -12.08104 -4.963685c-2.2414603 -4.4187555 -0.909603 -9.81259 3.1310139 -12.6801605c4.040616 -2.867571 9.571754 -2.3443127 13.002944 1.2301085l-2.8127813 2.7000687l0 0c-2.0935059 -2.1808972 -5.468274 -2.500158 -7.933616 -0.75053835c-2.4653416 1.74962 -3.277961 5.040613 -1.9103565 7.7366734c1.3676047 2.6960592 4.5031037 3.9843292 7.3711267 3.0285425c2.868022 -0.95578575 4.6038647 -3.8674583 4.0807285 -6.844941z" fillRule="evenodd"></path><path fill="currentColor" d="m10.000263 8.268785l9.847767 0l0 3.496233l-9.847767 0z" fillRule="evenodd">
                                                    </path>
                                                </g>
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                            </div>
                            <div className="relative mt-6">
                                <div className="absolute inset-0 flex items-center" aria-hidden="true">
                                    <div className="w-full border-t border-gray-300">
                                    </div>
                                </div>
                                <div className="relative flex justify-center text-sm"><span className="bg-white dark:bg-gray-900 px-2 text-gray-500">Or use email to signup</span>
                                </div>
                            </div>
                        </div> */}
                        <div className="mt-4">
                            <form className="space-y-2">
                                <div>
                                    <label htmlFor="Name" className="mb-1 block text-sm font-medium text-gray-700 dark:text-white">Name</label>
                                    <input name="Name" placeholder="Enter your name" autoComplete="off" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 focus:outline-none focus:ring-yellow-500 dark:text-black disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" defaultValue="" onChange={e => setName(e.target.value)} />
                                </div>
                                <div>
                                    <label htmlFor="Username" className="mb-1 block text-sm font-medium text-gray-700 dark:text-white">Username</label>
                                    <input name="Username" autoComplete="off" className="block w-full appearance-none rounded-md border border-gray-300  dark:text-black px-3 py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 focus:outline-none focus:ring-yellow-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" minLength="3" maxLength="15" pattern="^[a-zA-Z0-9]+$" placeholder="Only alphanumeric allowed [a-z, A-Z, 0-9]" type="text" defaultValue="" onChange={e => setUsername(e.target.value)} />
                                    <small className="ml-1 text-xs italic opacity-80">Once set, username cannot be changed</small>
                                </div>
                                <div>
                                    <label htmlFor="email" className="mb-1 dark:text-white block text-sm font-medium text-gray-700">Email Address</label>
                                    <input data-testid="email" placeholder="Enter your email address" autoComplete="off" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 dark:text-black focus:outline-none focus:ring-yellow-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" type="email" id="email" name="email" defaultValue="" onChange={e => setEmail(e.target.value)} />
                                </div>
                                <div>
                                    <label htmlFor="bname" className="mb-1 block text-sm dark:text-white font-medium text-gray-700">Business Name</label>
                                    <input name="bname" autoComplete="off" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 focus:outline-none focus:ring-yellow-500 dark:text-black disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" placeholder="Enter your business name" type="text" defaultValue="" onChange={e => setBname(e.target.value)} />
                                </div>
                                <div>
                                    <label htmlFor="pan" className="mb-1 block text-sm font-medium dark:text-white text-gray-700">PAN</label>
                                    <input name="pan" autoComplete="off" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 focus:outline-none focus:ring-yellow-500 dark:text-black disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" placeholder="Enter your PAN" type="text" defaultValue="" onChange={e => setPan(e.target.value)} />
                                </div>
                                <div>
                                    <label htmlFor="gst" className="mb-1 block text-sm font-medium text-gray-700 dark:text-white">GST number</label>
                                    <input name="gst" autoComplete="off" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 focus:outline-none focus:ring-yellow-500 dark:text-black disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" placeholder="Enter your GST number" type="text" defaultValue="" onChange={e => setGst(e.target.value)} />
                                </div>
                                <div>
                                    <div>
                                        <label htmlFor="Password" className="mb-1 block text-sm font-medium text-gray-700 dark:text-white">Password</label>
                                        <input data-testid="password" name="Password" placeholder="Enter a new password" autoComplete="off" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 focus:outline-none focus:ring-yellow-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm dark:text-black" required="" minLength="5" maxLength="50" type="password" defaultValue="" onChange={e => setPassword(e.target.value)} />
                                    </div>
                                </div>
                                <div>
                                    <button data-testid="login" type="submit" className="group relative flex w-full justify-center rounded-md border border-transparent bg-yellow-600 px-4 py-2 text-sm font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 disabled:cursor-wait disabled:opacity-50" onClick={e => handleSignup(e)}>
                                        Submit Details
                                    </button>
                                    <small className="mt-3 flex justify-center">
                                        <span>Click submit details to proceed and<strong> verify your email</strong>
                                        </span>
                                    </small>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>


            <div className=' bottom-0 w-full'>
                <SmallFooter />
            </div>

        </div>
    )
}

export default Register